 <template>
<div><div style="position:fixed;width:100%;left:0;height:100%;top:0;z-index:99" v-if="dialogOaAuditPrinting"><img src="../../assets/porint-bg.png" width="100%" height="100%"></div>
  <el-dialog v-model="dialogOaAuditPrinting" :fullscreen="true" :append-to-body="true" :show-close="false">
    <div class="oa-audit-printing" v-if="dialogOaAuditPrinting" id="oa-audit-printing">
      <oa-audit-printing-children v-model:printingDataChil="printingData.approving.formdata"
                                  v-model:printingDataChil2="printingData1"
                                  :defaultPrintShowKey="defaultPrintShowKey"
                                  v-model:printingDataChil3="printingType" :isTime="isTime"></oa-audit-printing-children>
      <div class="footer-state">
        <div class="prin-date">打印时间：{{currentdate}}</div>
        <div v-if="printingData.approving.status == '1'||printingData.approving.status == '2'" class="form-result">
          处理结果：
          <span class="form-result-wrap">
            <img src="../../assets/form-result1.png" v-if="printingData.approving.status == '1'"/>
            <img src="../../assets/form-result2.png" v-else-if="printingData.approving.status == '2'"/>
          </span>
        </div>
      </div>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import oaAuditPrintingChildren from './oaAuditPrintingChildren'
  import printJS from "../../../public/static/print/print.min"
  export default {
    name: "oa-audit-printing",
    mounted(){
    },
    components:{
      oaAuditPrintingChildren
    },
    data(){
      return{
        tableData:[],
        isdata:1,
        printingData:null,
        printingData1:null,
        dialogOaAuditPrinting:false,
        currentdate:null,
        printingType:1,
        isTime: 0, // 0 显示 1 不显示
        defaultPrintShowKey: {}
      }
    },
    methods:{
      oaAuditPrintingChildFun(dataObj, dataObj1, defaultPrintShowKey = {}){
        dataObj1.orders = dataObj.approving.orders;
        this.dialogOaAuditPrinting = true;
        this.defaultPrintShowKey = defaultPrintShowKey
        this.printingData = dataObj;
        this.printingData1 = dataObj1;
        //打印时间。当前时间
        var thisDate = new Date();
        var seperator1 = "-";
        var thisYear = thisDate.getFullYear();
        var thisMonth = thisDate.getMonth() + 1;
        var thisStrDate = thisDate.getDate();
        this.isTime = dataObj.istime ? dataObj.istime : 0;
        if (thisMonth >= 1 && thisMonth <= 9) {
          thisMonth = "0" + thisMonth;
        }
        if (thisStrDate >= 0 && thisStrDate <= 9) {
          thisStrDate = "0" + thisStrDate;
        }
        var currentdate = thisYear + seperator1 + thisMonth + seperator1 + thisStrDate;
        this.currentdate = currentdate;
        //打印设置
        setTimeout(()=>{
          printJS({
            printable: 'oa-audit-printing',
            type: 'html',
            css: '../../../static/print/oaAuditPrinting.css',
            scanStyles: false
          });
          this.dialogOaAuditPrinting = false;
          var isdata = this.isdata;
          this.$emit('eventPrintingChild',isdata); //自定义事件来关闭oaExamineAudit.vue页面的弹窗
        },500);
      },
    },
  }
</script>

<style scoped>
@import '../../../public/static/print/oaAuditPrinting.css';
</style>
